export default __webpack_public_path__ + "static/media/1980.de9f1268.jpg";